// Story 60.1 (EO-372): the client-side mirror of the backend's
// utils.NormalizeVatId (backend/shared/utils/vatid.go), used by the brand-site
// signup form and the admin console's tenant settings. The server stays the
// authority — this only lets a form say "that is not a VAT id" before submit
// and send the same normalised value the server would store.
//
// Specs live in brand-site (src/app/pages/signup/vat-id.spec.ts): only a
// project's src/**/*.spec.ts globs are compiled by ng test.
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/** Two-letter country prefix + 2-13 letters or digits — the EU envelope. Shape only, no VIES. */
export const VAT_ID_PATTERN = /^[A-Z]{2}[A-Z0-9]{2,13}$/;

/** Trims, removes spaces, tabs, hyphens and dots, upper-cases. '' means no VAT id. */
export function normalizeVatId(raw: string | null | undefined): string {
  // Exactly the backend's set ( , \t, -, .) — not \s, or a value with an inner
  // non-breaking space would pass here and fail on the server.
  return (raw ?? '').trim().replace(/[ \t.-]/g, '').toUpperCase();
}

/** `{vatId: true}` when the normalised value is non-empty and outside the envelope. */
export const vatIdValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const v = normalizeVatId(control.value as string | null);
  return v === '' || VAT_ID_PATTERN.test(v) ? null : {vatId: true};
};
